import Vue from 'vue'
import Router from 'vue-router'
import DevicesList from '@/components/DevicesList'
import DevicesListProvision from '@/components/DevicesListProvision'

import Device from '@/components/Device'
import Login from '@/components/Login'
import BalenaLogs from '@/components/BalenaLogs'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: {
                name: "Login"
            }
        },
        {
            path: '/device-list',
            name: 'DevicesList',
            component: DevicesList
        },
        {
          path: '/device-list-provision',
          name: 'DevicesList',
          component: DevicesListProvision
        },
        {
            path: '/device/:uuid',
            name: 'Device',
            component: Device
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/balenaLogs',
            name: 'BalenaLogs',
            component: BalenaLogs
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js